import { render } from "./Tcp.vue?vue&type=template&id=a88d9f2a&lang=pug"
import script from "./Tcp.vue?vue&type=script&lang=js"
export * from "./Tcp.vue?vue&type=script&lang=js"

import exportComponent from "/home/apognu/code/personal/defcon/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__